import { RESET_FORM_DATA, SET_FORM_DATA } from "./types"

export const setFormData = payload => {
    return { type: SET_FORM_DATA, payload };
}

export const resetFormData = payload => {
    return { type: RESET_FORM_DATA, payload };
}